<template>
  <div class="signup view">
    <Card tag="form" @submit.prevent="submit" class="signup__widget">
      <template #header>
        <FontAwesomeIcon :icon="['fal', 'user-circle']" size="5x" />
        <h1>{{ $t('welcomeToKvassName', { name: $route.query.name }) }}</h1>
        <div v-if="!completed" class="signup__instruction">{{ $t('enterPasswordAndClickComplete') }}</div>
      </template>
      <template #default>
        <div class="col g-1">
          <template v-if="!completed">
            <InputComponent
              v-model="data.password"
              :label="labels.password"
              required
              type="password"
              :is-valid="validator.fields.password.valid"
              :validation-message="validator.fields.password.error"
            />
            <InputComponent
              v-model="data.repeatPassword"
              :label="labels.repeatPassword"
              required
              type="password"
              :is-valid="validator.fields.repeatPassword.valid"
              :validation-message="validator.fields.repeatPassword.error"
            />
            <Alert>{{ $t('passwordEnforcementMessage') }}</Alert>
            <Alert v-if="isInvalid" theme="error">{{ $t('tokenExpiredRequestNew') }}</Alert>
          </template>
          <div v-else class="p-2 text--center">
            <strong>{{ $t('registrationComplete') }}</strong
            ><br />{{ $t('clickToLogin') }}
          </div>
        </div>
      </template>
      <template #footer>
        <div class="row center">
          <ButtonComponent
            v-if="!completed"
            :label="$t('complete')"
            :disabled="!validator.passes"
            type="submit"
            theme="primary"
            :promise="promise"
            :icon="['fal', 'angle-right']"
          />
          <ButtonComponent v-if="completed" :label="$t('login')" theme="success" @click="onClick" />
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import Validator from '@/mixins/validator'
import Card from '@/components/Card'
import { AlertComponent as Alert } from 'vue-elder-alert'
import UserApi from '@/api/User'

export default {
  mixins: [Validator],
  props: {
    token: String,
  },
  data() {
    return {
      promise: null,
      isInvalid: false,
      completed: false,
      data: {
        password: null,
        repeatPassword: null,
      },
      validator: {
        rules: {
          password: 'required|password',
          repeatPassword: 'required|same:password',
        },
        labels: 'labels',
        data: 'data',
      },
    }
  },
  computed: {
    labels() {
      return {
        password: this.$t('password'),
        repeatPassword: this.$t('repeatPassword'),
      }
    },
  },
  methods: {
    submit() {
      if (!this.validator.passes) return
      this.promise = UserApi.signup({ token: this.token, password: this.data.password })
        .then(() => {
          this.completed = true
        })
        .catch(err => {
          if (err.status == 404) this.isInvalid = true
          throw new Error('Confirmation token has expired')
        })
    },
    onClick() {
      window.location.href = '/'
    },
  },
  metaInfo() {
    return {
      title: this.$t('getStarted'),
    }
  },
  components: {
    Card,
    InputComponent,
    Alert,
  },
}
</script>

<style lang="scss">
.signup {
  background-color: $background-grey;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    margin: 1rem 0 0 0;
    font-size: 1.5rem;
  }

  &__instruction {
    opacity: 0.5;
    margin-top: 0.5rem;
    text-align: center;
  }

  &__widget {
    flex-grow: 1;
    max-width: 450px;
  }
}
</style>
